var MapService_1;
import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import Map from "@arcgis/core/Map";
import MapView from "@arcgis/core/views/MapView";
import Graphic from "@arcgis/core/Graphic";
import esriConfig from "@arcgis/core/config";
import { MapTools } from "./map.tools";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import { AppConfig } from "../../app.config";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer";
import SpatialReference from "@arcgis/core/geometry/SpatialReference";
import { AppRoutingConstants } from "../../app-routing.constants";
import { CreateApplicationRoutingConstants } from "../../create-application/create-application-routing.constants";
import { AuthService } from "../../shared/services/auth/auth.service";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import TileLayer from "@arcgis/core/layers/TileLayer";
import { HttpClient } from "@angular/common/http";
import { ApiModuleMapConstants } from "../../shared/constants/api-constants/api-module-map.constants";
import { ApiProxyConstants } from "../../shared/constants/api-constants/api-proxy.constants";
import { UserInformationService } from "../../shared/services/user/user-information.service";
import * as identify from "@arcgis/core/rest/identify";
import { BehaviorSubject, Subject } from "rxjs";
import * as rxjsOperators from "rxjs/operators";
import ImageryLayer from "@arcgis/core/layers/ImageryLayer";
import ImageryTileLayer from "@arcgis/core/layers/ImageryTileLayer";
import VectorTileLayer from "@arcgis/core/layers/VectorTileLayer";
import WMTSLayer from "@arcgis/core/layers/WMTSLayer";
import WMSLayer from "@arcgis/core/layers/WMSLayer";
import Query from "@arcgis/core/rest/support/Query";
import { Location } from "@angular/common";
import { RequestStatusService } from "../../shared/services/request-status/request-status.service";
import Extent from "@arcgis/core/geometry/Extent";
import LOD from "@arcgis/core/layers/support/LOD";
import { AppControllerService } from "../../app-controller.service";
import { AlertType } from "../../shared/models/alert";
import LayerSearchSource from "@arcgis/core/widgets/Search/LayerSearchSource";
import { ModuleConfigService } from "../../shared/services/module-config/module-config.service";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";
import { MapServiceConstants } from "../../shared/constants/map-service.constants";
import { map, take } from "rxjs/operators";
import { AutoUnsubPortal } from "../../shared/decorators/autounsub-portal.decorator";
import { SystemModuleSettingsService } from "../../shared/services/system-module-settings.service";
import IdentityManager from "@arcgis/core/identity/IdentityManager";
let MapService = class MapService {
    static { MapService_1 = this; }
    mapTools;
    http;
    authService;
    moduleSettingsService;
    userInformationService;
    moduleConfigService;
    location;
    requestStatusService;
    appController;
    // TODO: Are the MapDefault settings going to be set up in the config?
    // inner class used for internal map defaults if none are provided
    static MapDefaults = class {
        baseMap = "streets-vector";
        center = [23.273294, -33.946994];
        zoom = 10;
    };
    showPopups = true;
    actionPropertyEnabled = false;
    actionPropertyOwnerEnabled = false;
    actionGraveEnabled = false;
    actionBayEnabled = false;
    actionPOIEnabled = false;
    actionStreetEnabled = false;
    userMaps;
    layersLoadedSubject = new Subject();
    $layersLoaded = this.layersLoadedSubject.asObservable();
    removeAllMapToolGraphicsSubject = new Subject();
    $removeAllMapToolGraphics = this.removeAllMapToolGraphicsSubject.asObservable();
    layerTokens = [];
    isSysAdmin = false;
    mapFilter = "moduleId eq  ";
    _mapDefaults;
    _mapView;
    selectionLayers = [];
    layersLoading = 0;
    forbiddenFields = [
        "shape",
        "startdate",
        "endDate",
        "registered",
        "OBJECTID",
        "Shape_Length",
        "Shape_Area",
        "PremiseID",
        "HasGeometry",
        "Property_OBJECTID",
        "ModuleID",
        "GlobalID",
        "CemeteryID"
    ].map(field => field.toLowerCase());
    selectedPropertySubject = new Subject();
    $selectedProperty = this.selectedPropertySubject.asObservable();
    selectedPropertyOwnerSubject = new Subject();
    $selectedOwnerProperty = this.selectedPropertyOwnerSubject.asObservable();
    selectedGraveSubject = new Subject();
    $selectedGrave = this.selectedGraveSubject.asObservable();
    selectedBaySubject = new Subject();
    $selectedBay = this.selectedBaySubject.asObservable();
    selectedPOISubject = new Subject();
    $selectedPOISubject = this.selectedPOISubject.asObservable();
    selectedStreetSubject = new Subject();
    $selectedStreetSubject = this.selectedStreetSubject.asObservable();
    proceedMapLoading = new BehaviorSubject(false);
    $proceedMapLoading = this.proceedMapLoading.asObservable();
    authUserInformation;
    applicationLayer = new BehaviorSubject(null);
    getModuleMapsSubscription;
    constructor(mapTools, http, authService, moduleSettingsService, userInformationService, moduleConfigService, location, requestStatusService, appController) {
        this.mapTools = mapTools;
        this.http = http;
        this.authService = authService;
        this.moduleSettingsService = moduleSettingsService;
        this.userInformationService = userInformationService;
        this.moduleConfigService = moduleConfigService;
        this.location = location;
        this.requestStatusService = requestStatusService;
        this.appController = appController;
        this._mapDefaults = new MapService_1.MapDefaults();
        this.getAuthUserInformation();
    }
    static drawGraphic(graphic, graphicsLayer) {
        graphicsLayer.add(graphic);
    }
    static addGraphicsLayer(mapView, layerReference) {
        if (mapView !== undefined && mapView !== null && mapView.map !== undefined && mapView.map !== null && mapView.map) {
            let graphicsLayer = null;
            if (layerReference !== null) {
                mapView.map.layers.forEach(item => {
                    // tslint:disable-next-line:triple-equals
                    if (item.type === "graphics" && item.id == layerReference && graphicsLayer === null) {
                        graphicsLayer = item;
                    }
                });
            }
            if (graphicsLayer === null) {
                graphicsLayer = new GraphicsLayer({
                    listMode: "hide",
                    id: layerReference ? layerReference : "graphicsLayer"
                });
                mapView.map.add(graphicsLayer);
            }
            return graphicsLayer;
        }
    }
    static removeGraphicsLayer(mapView, layerReference) {
        if (mapView !== undefined && mapView !== null && mapView.map !== undefined && mapView.map !== null &&
            mapView.map && mapView.map.layers.length > 0) {
            mapView.map.layers.forEach((layer) => {
                if (layer.type === "graphics" && layer.id === layerReference) {
                    mapView.map.layers.remove(layer);
                }
            });
        }
    }
    static getStartApplicationRoute() {
        const route = `${CreateApplicationRoutingConstants.CREATE_APPLICATION_ROUTE}\
     ${AppRoutingConstants.ROUTE_SEPERATOR}\
     ${CreateApplicationRoutingConstants.DETAILS_ROUTE}`;
        const emptySpaceRe = new RegExp(" ", "gi");
        return route.replace(emptySpaceRe, "");
    }
    setProceedMapLoading(proceed) {
        this.proceedMapLoading.next(proceed);
    }
    destroyMap() {
        this.actionPropertyEnabled = false;
        this.actionPropertyOwnerEnabled = false;
        this.actionGraveEnabled = false;
        this.actionBayEnabled = false;
        this.actionPOIEnabled = false;
        this.actionStreetEnabled = false;
        this.userMaps = [];
        this.layerTokens = [];
        this._mapView = null;
        this.layersLoading = 0;
        this.mapTools.mapTools = [];
    }
    async displayMap(mapViewEl, mapDefaults = this._mapDefaults, moduleId) {
        if (!mapViewEl) {
            throw new Error("Map View element doesnt exist");
        }
        this.requestStatusService.showBusySpinner("LoadingEsriMap");
        const mapView = this.getMapView(mapDefaults, moduleId);
        if (mapView) {
            mapView.container = mapViewEl.nativeElement;
        }
        await mapView.when(() => {
            this.userMaps = [];
            // this.addActions();
        }, (error) => {
            console.log(error);
        });
        // mapView.watch("popup.selectedFeature", () => expandActionBar());
        // mapView.on("resize", () => expandActionBar());
        //
        // const expandActionBar = () => {
        //   const actionBar = document.querySelector(".esri-popup__main-container calcite-action-bar");
        //   if (actionBar) {
        //     actionBar.setAttribute("expanded", "");
        //     actionBar.setAttribute("overflow-actions-disabled", "");
        //   }
        // };
        return mapView;
    }
    toggleBuffer(event) {
        this.mapTools.toggleBuffer(event);
    }
    removeAllMapToolGraphics() {
        this.removeAllMapToolGraphicsSubject.next(true);
    }
    fetchModuleData(moduleId, showOnlyPropertyAndZoningLayers = false, showOnlyOrganisationMaps = false, showApplicationsAndBasemapLayers) {
        const params = {
            $filter: "",
            $orderby: "mapOrder desc"
        };
        if (showOnlyOrganisationMaps === true) {
            params.$filter = `moduleId eq null`;
        }
        else {
            params.$filter = `moduleId eq ${moduleId} or (moduleId eq null and organisationId eq ${this.userInformationService.getOrganisationId(moduleId)})`;
        }
        this.getModuleMapsSubscription = this.http.get(`${ApiModuleMapConstants.URL}/${ApiModuleMapConstants.FUNCTION_GET_MODULE_MAP_FOR_AFLA_PORTAL}`, { params })
            .subscribe((response) => {
            this.userMaps = [];
            const urls = [];
            const loadedIds = [];
            this.selectionLayers = [];
            response.value.sort((a, b) => 0 - (a.mapOrder > b.mapOrder ? -1 : 1));
            for (const item of response.value) {
                if (item.moduleId !== undefined && item.moduleId !== null) {
                    urls.push(item.url);
                    if (item.selectionLayerType !== undefined && item.selectionLayerType !== null) {
                        this.selectionLayers.push(item.selectionLayerType);
                    }
                    const addedLayer = this.addLayer(item.url, item.type, item.name, item.selectionLayerType, item.defaultVisibility, showOnlyPropertyAndZoningLayers, showApplicationsAndBasemapLayers);
                    item.layer = addedLayer;
                    this.userMaps.push(item);
                    loadedIds.push(item.id);
                }
            }
            for (const item of response.value) {
                if (loadedIds.indexOf(item.id) === -1) {
                    if (item.moduleId === undefined || item.moduleId === null && urls.indexOf(item.url) === -1) {
                        if (item.selectionLayerType !== undefined && item.selectionLayerType !== null) {
                            if (this.selectionLayers.indexOf(item.selectionLayerType) >= 0) {
                                continue;
                            }
                            this.selectionLayers.push(item.selectionLayerType);
                        }
                        urls.push(item.url);
                        const addedLayer = this.addLayer(item.url, item.type, item.name, item.selectionLayerType, item.defaultVisibility, showOnlyPropertyAndZoningLayers, showApplicationsAndBasemapLayers);
                        item.layer = addedLayer;
                        this.userMaps.push(item);
                    }
                }
            }
            const foundAppLayer = this.userMaps.find(a => a.selectionLayerType === MapServiceConstants.APPLICATION_LAYER);
            this.applicationLayer.next(foundAppLayer?.layer);
            if (this.userMaps.length === 0) {
                this.requestStatusService.removeBusySpinner("LoadingEsriMap");
                this.layersLoadedSubject.next(true);
            }
            // Get the secure layer tokens here so that we don't have to make another asynchronous call when we intercept the print task
            this.userMaps.forEach((layer) => {
                const paramsIndex = layer.url.indexOf("/rest");
                const paramsDomain = layer.url.slice(0, paramsIndex);
                const mapIndex = AppConfig.settings.arcGIS.printServiceURL.indexOf("/rest");
                const mapDomain = AppConfig.settings.arcGIS.printServiceURL.slice(0, mapIndex);
                if (paramsDomain !== mapDomain) {
                    const tokenRequestParams = this.getTokenRequestParams(layer);
                    if (tokenRequestParams) {
                        const getLayerTokenHeaders = {
                            MapServiceId: tokenRequestParams.MapServiceId,
                            Authorization: tokenRequestParams.authorization
                        };
                        const apiUrl = AppConfig.settings.api.server + "/api";
                        this.getLayerToken(`${apiUrl.replace(AppRoutingConstants.API_PREFIX, ApiProxyConstants.URL_LAYER_TOKEN)}?${layer.url}`, { headers: getLayerTokenHeaders }).subscribe((token) => {
                            const layerToken = this.layerTokens.filter((l) => l.id === layer.id);
                            // Avoid duplicates
                            if (layerToken.length < 1) {
                                this.layerTokens.push({
                                    layer,
                                    auth: token
                                });
                            }
                        }, (error) => {
                            console.log(error);
                        });
                    }
                }
            });
            this.checkIfMapsAreLoaded();
        });
    }
    async fetchMapData(moduleId) {
        const params = {
            $filter: `moduleId eq ${moduleId}`
        };
        params.$filter = `moduleId eq ${moduleId}`;
        await this.http.get(`${ApiModuleMapConstants.URL}/${ApiModuleMapConstants.FUNCTION_GET_MODULE_MAP_FOR_AFLA_PORTAL}`, { params })
            .pipe(take(1))
            .subscribe((response) => {
            this.userMaps = [];
            const urls = [];
            const loadedIds = [];
            this.selectionLayers = [];
            response.value.sort((a, b) => 0 - (a.mapOrder > b.mapOrder ? -1 : 1));
            for (const item of response.value) {
                if (item.moduleId !== undefined && item.moduleId !== null) {
                    urls.push(item.url);
                    if (item.selectionLayerType !== undefined && item.selectionLayerType !== null) {
                        this.selectionLayers.push(item.selectionLayerType);
                    }
                    const addedLayer = this.addLayer(item.url, item.type, item.name, item.selectionLayerType, item.defaultVisibility, false, false);
                    item.layer = addedLayer;
                    this.userMaps.push(item);
                    loadedIds.push(item.id);
                }
            }
        });
    }
    addGeometriesAsGraphics(geometries, mapView, layerReference, clearBeforeAdd) {
        this.addGraphics(this.transformGeometryToGraphic(geometries), mapView, layerReference, clearBeforeAdd);
    }
    removeGraphicsLayer(mapView, layerReference) {
        MapService_1.removeGraphicsLayer(mapView, layerReference);
    }
    // Required to get Esri Worker
    externalEsriLoader() {
        esriConfig.assetsPath = this.location.prepareExternalUrl("assets");
    }
    executeIdentifyTask(event, params, url, mapView) {
        if (this.showPopups === true) {
            let canShowPopups = false;
            this.userMaps.forEach(item => {
                if (item.url === url) {
                    canShowPopups = true;
                }
            });
            if (canShowPopups) {
                params.geometry = event.mapPoint;
                params.mapExtent = mapView.extent;
                identify.identify(url, params).then((response) => {
                    const results = response.results;
                    return results.map((result) => {
                        const feature = result.feature;
                        const layerName = result.layerName;
                        feature.attributes.layerName = layerName;
                        const fields = [];
                        for (const [key, value] of Object.entries(feature.attributes)) {
                            fields.push({ fieldName: key, label: key });
                        }
                        feature.popupTemplate = {
                            title: layerName, content: [{
                                    type: "fields", fieldInfos: fields
                                }]
                        };
                        return feature;
                    });
                })
                    .then(response => {
                    if (response && this.showPopups === true) {
                        this.showPopup(event, response, mapView);
                    }
                });
            }
        }
    }
    executeQueryTask(event, layer, layerName, mapView, url) {
        if (layer.popupEnabled) {
            let canShowPopups = false;
            let canShowPropertyAction = false;
            let canShowPropertyOwnerAction = false;
            let canShowGraveAction = false;
            let canShowBayAction = false;
            let canShowPOIAction = false;
            let canShowStreetAction = false;
            this.userMaps.forEach(item => {
                if (item.url === url) {
                    canShowPopups = true;
                    if (item.selectionLayerType.toLowerCase() === "property" && this.actionPropertyEnabled) {
                        canShowPropertyAction = true;
                    }
                    if (item.selectionLayerType.toLowerCase() === "application") {
                        canShowPropertyAction = true;
                    }
                    if (item.selectionLayerType.toLowerCase() === "property owner" && this.actionPropertyOwnerEnabled) {
                        canShowPropertyOwnerAction = true;
                    }
                    if (item.selectionLayerType.toLowerCase() === "grave" && this.actionGraveEnabled) {
                        canShowGraveAction = true;
                    }
                    if (item.selectionLayerType.toLowerCase() === "bays" && this.actionBayEnabled) {
                        canShowBayAction = true;
                    }
                    if (item.selectionLayerType.toLowerCase() === "poi" && this.actionPOIEnabled) {
                        canShowPOIAction = true;
                    }
                    if (item.selectionLayerType.toLowerCase() === "street" && this.actionStreetEnabled) {
                        canShowStreetAction = true;
                    }
                }
            });
            const geometry = event.mapPoint;
            const query = new Query();
            query.geometry = geometry;
            query.distance = this.getBufferByModule();
            query.units = "meters";
            query.returnGeometry = true;
            query.outFields = ["*"];
            query.where = "1=1";
            layer.queryFeatures(query).then((results) => {
                const features = results.features;
                return features.map((feature) => {
                    feature.attributes.layerName = layerName;
                    const fields = [];
                    for (const [key, value] of Object.entries(feature.attributes)) {
                        let alias = key;
                        results.fields.forEach(field => {
                            if (field.name === key) {
                                alias = field.alias;
                            }
                        });
                        fields.push({ fieldName: key, label: alias });
                    }
                    const template = {
                        title: layerName,
                        content: [{
                                type: "fields",
                                fieldInfos: fields
                            }],
                        actions: []
                    };
                    if (canShowPropertyAction) {
                        const propertyAction = {
                            title: "Add property",
                            id: "add-property",
                            image: "assets/images/plus.png"
                        };
                        template.actions.push(propertyAction);
                    }
                    if (canShowBayAction) {
                        const bayAction = {
                            title: "Add bay",
                            id: "add-bay",
                            image: "assets/images/plus.png"
                        };
                        template.actions.push(bayAction);
                    }
                    if (canShowPropertyOwnerAction) {
                        const propertyOwnerAction = {
                            title: "Add property owner",
                            id: "add-property-owner",
                            image: "assets/images/plus.png"
                        };
                        template.actions.push(propertyOwnerAction);
                    }
                    if (canShowPOIAction) {
                        const poiAction = {
                            title: "Select POI",
                            id: "add-POI",
                            image: "assets/images/plus.png"
                        };
                        template.actions.push(poiAction);
                    }
                    if (canShowStreetAction) {
                        const streetAction = {
                            title: "Select street",
                            id: "add-street",
                            image: "assets/images/plus.png"
                        };
                        template.actions.push(streetAction);
                    }
                    if (canShowGraveAction) {
                        const graveAction = {
                            title: "Add grave",
                            id: "add-grave",
                            image: "assets/images/plus.png"
                        };
                        template.actions.push(graveAction);
                    }
                    feature.popupTemplate = template;
                    this.addActions();
                    return feature;
                });
            })
                .then(response => {
                if (response && layer.popupEnabled) {
                    this.showPopup(event, response, mapView);
                }
            });
        }
    }
    clearGraphics(mapView, layerReference) {
        const graphicsLayer = MapService_1.addGraphicsLayer(mapView, layerReference);
        if (graphicsLayer) {
            graphicsLayer.removeAll();
        }
    }
    filterApplicationsByAuthUser($authenticatedUser) {
        $authenticatedUser.subscribe((authUser) => {
            this._mapView.map.layers.forEach((layer) => {
                if (layer.hasOwnProperty("sublayers")) {
                    const subLayers = layer.sublayers;
                    subLayers.forEach((sublayer) => {
                        sublayer.definitionExpression = `CreatedUserId = ${authUser?.id}`;
                        sublayer.visible = true;
                    });
                }
            });
        });
    }
    addActions() {
        let isProcessing = false;
        this._mapView?.popup.on("trigger-action", (event) => {
            if (isProcessing)
                return;
            isProcessing = true;
            const selectedFeature = this._mapView.popup.selectedFeature;
            if (event.action.id === "add-property") {
                this.selectedPropertySubject.next(selectedFeature);
            }
            else if (event.action.id === "add-property-owner") {
                this.selectedPropertyOwnerSubject.next(selectedFeature);
            }
            else if (event.action.id === "add-grave") {
                this.selectedGraveSubject.next(selectedFeature);
            }
            else if (event.action.id === "add-bay") {
                this.selectedBaySubject.next(selectedFeature);
            }
            else if (event.action.id === "add-POI") {
                this.selectedPOISubject.next(selectedFeature);
            }
            else if (event.action.id === "add-street") {
                this.selectedStreetSubject.next(selectedFeature);
            }
            // Reset the processing flag after a short delay
            setTimeout(() => {
                isProcessing = false;
            }, 1000); // Adjust the delay as needed
        });
    }
    checkForSysAdmin(mapView) {
        this.userInformationService.$userInformationFetched.subscribe((fetched) => {
            if (fetched) {
                this.isSysAdmin = this.userInformationService.isSysadminAdmin();
                this.mapTools.addExtent(mapView, this.isSysAdmin);
            }
        });
    }
    getAuthUserInformation() {
        this.userInformationService.$authenticatedUser.subscribe({
            next: (authUser) => {
                this.authUserInformation = authUser;
            }
        });
    }
    addLayer(url, type, title, selectionLayerType, defaultVisibility, showOnlyPropertyAndZoningLayers, showApplicationsAndBasemapLayers) {
        let layer = null;
        switch (type) {
            case "MapImageLayer": {
                this.layersLoading++;
                layer = new MapImageLayer({
                    url,
                    title,
                    visible: defaultVisibility
                });
                break;
            }
            case "TileLayer": {
                this.layersLoading++;
                layer = new TileLayer({
                    url,
                    title,
                    visible: defaultVisibility
                });
                break;
            }
            case "FeatureLayer": {
                this.layersLoading++;
                layer = new FeatureLayer({
                    url,
                    title,
                    visible: defaultVisibility
                });
                break;
            }
            case "ImageryLayer": {
                this.layersLoading++;
                layer = new ImageryLayer({
                    url,
                    title,
                    visible: defaultVisibility
                });
                break;
            }
            case "ImageryTileLayer": {
                this.layersLoading++;
                layer = new ImageryTileLayer({
                    url,
                    title,
                    visible: defaultVisibility
                });
                break;
            }
            case "VectorTileLayer": {
                this.layersLoading++;
                layer = new VectorTileLayer({
                    url,
                    title,
                    visible: defaultVisibility
                });
                break;
            }
            case "WMSLayer": {
                this.layersLoading++;
                layer = new WMSLayer({
                    url,
                    title,
                    visible: defaultVisibility
                });
                break;
            }
            case "WMTSLayer": {
                this.layersLoading++;
                layer = new WMTSLayer({
                    url,
                    title,
                    visible: defaultVisibility,
                });
                break;
            }
            default: {
                break;
            }
        }
        if (!showApplicationsAndBasemapLayers && selectionLayerType === MapServiceConstants.APPLICATION_LAYER || !showApplicationsAndBasemapLayers && selectionLayerType === MapServiceConstants.AFLA_PORTAL_APPLICATION_LAYER) {
            // prevent adding applications layer and base maps on create application location steps
            this.layerAdded(null);
            return layer;
        }
        if (layer !== null && this._mapView) {
            // owner layer not added to the map but is required in the background for the UserMaps array
            if (!showOnlyPropertyAndZoningLayers || (selectionLayerType === MapServiceConstants.PROPERTY_LAYER || selectionLayerType === MapServiceConstants.PROPERTY_ZONING_LAYER)) {
                // @ts-ignore
                layer.legendEnabled = true;
                this._mapView.map.add(layer);
                layer.on("layerview-create", event => {
                    this.layerAdded(event);
                });
                layer.on("layerview-create-error", event => {
                    this.layerAdded(event);
                });
            }
            else {
                // need to remove the spinner if the layer was not loaded to the map
                this.layerAdded(null);
            }
        }
        return layer;
    }
    layerAdded(event) {
        this.layersLoading--;
        if (this.layersLoading === 0) {
            this.requestStatusService.removeBusySpinner("LoadingEsriMap");
            this.layersLoadedSubject.next(true);
        }
    }
    showPopup(event, response, mapView) {
        if (response.length > 0) {
            mapView.popup.dockOptions = {
                breakpoint: false,
                buttonEnabled: false,
                position: "bottom-left"
            };
            mapView.popup.open({
                features: response,
                location: event.mapPoint
            });
            // remove this when upgrading calcite: this is a hack to get the beta working
            setTimeout(() => {
                try {
                    //document.querySelector("calcite-flow-item").shadowRoot.querySelector("calcite-panel").shadowRoot.querySelector(".header").setAttribute("style", "display:none;");
                    document.querySelector("calcite-flow-item").shadowRoot.querySelector("calcite-panel").shadowRoot.querySelector(".footer").setAttribute("style", "display:none;");
                    const actionBar = document.querySelector(".esri-popup__main-container calcite-action-bar");
                    if (actionBar) {
                        actionBar.removeAttribute("slot");
                        actionBar.removeAttribute("expandDisabled");
                        actionBar.setAttribute("expanded", "");
                        actionBar.setAttribute("overflowActionsDisabled", "");
                    }
                    const cf = document.querySelector(".esri-features__content-feature");
                    const panel = cf?.shadowRoot?.querySelector("calcite-panel");
                    // Inject persistent style into calcite-panel's shadow root
                    const style = document.createElement("style");
                    style.textContent = `.header calcite-action-menu {
              display: none !important;
            }`;
                    panel.shadowRoot.appendChild(style);
                    const actionGroup = actionBar.querySelector("calcite-action-group");
                    if (actionGroup) {
                        actionGroup.setAttribute("layout", "horizontal");
                    }
                }
                catch (e) {
                    // ignore all errors
                }
            }, 350);
        }
    }
    transformGeometryToGraphic(geometries) {
        const graphics = [];
        geometries.forEach(item => {
            let symbol = {};
            if (item.type === "mesh") {
                symbol = AppConfig.settings.selectedGeometrySymbols.mesh;
            }
            else if (item.type === "point" || item.type === "multipoint") {
                symbol = AppConfig.settings.selectedGeometrySymbols.point;
            }
            else if (item.type === "polyline") {
                symbol = AppConfig.settings.selectedGeometrySymbols.polyline;
            }
            else {
                symbol = AppConfig.settings.selectedGeometrySymbols.polygon;
            }
            const graphic = new Graphic({ geometry: item, symbol });
            graphics.push(graphic);
        });
        return graphics;
    }
    addGraphics(graphics, mapView, layerReference, clearBeforeAdd) {
        const graphicsLayer = MapService_1.addGraphicsLayer(mapView, layerReference);
        if (graphicsLayer) {
            if (clearBeforeAdd !== null && clearBeforeAdd === true) {
                graphicsLayer.removeAll();
            }
            if (graphics && graphics.length > 0 && mapView) {
                graphics.forEach(graphic => {
                    MapService_1.drawGraphic(graphic, graphicsLayer);
                });
                if (graphics[graphics.length - 1].geometry.extent !== null) {
                    mapView.goTo(graphics[graphics.length - 1].geometry.extent.expand(1.2)).then().catch((error) => {
                        // This function returns a promise which resolves as soon as the new view has been set to the target.
                        // If setting the view to the new target fails, the promise returned by the goTo() method rejects with an error. Use a catch statement, to handle the error
                        if (error.name !== "AbortError") {
                            console.error(error);
                        }
                    });
                }
                else {
                    mapView.goTo(graphics[graphics.length - 1].geometry).then().catch((error) => {
                        // This function returns a promise which resolves as soon as the new view has been set to the target.
                        // If setting the view to the new target fails, the promise returned by the goTo() method rejects with an error. Use a catch statement, to handle the error
                        if (error.name !== "AbortError") {
                            console.error(error);
                        }
                    });
                }
            }
            // mapView.map.add(graphicsLayer);
        }
    }
    createMapView(mapDefaults, moduleId) {
        const mapProperties = {
            basemap: mapDefaults.baseMap
        };
        const map = new Map(mapProperties);
        let mapViewProperties = {};
        const levelOfDetails = [];
        let lodIndex = 1;
        if (AppConfig.settings.defaultMapScales.length > 0) {
            AppConfig.settings.defaultMapScales.forEach((scale) => {
                if (scale.show.toLowerCase() === "true") {
                    const lod = new LOD({ level: lodIndex, levelValue: lodIndex.toString(), scale: scale.scale });
                    levelOfDetails.push(lod);
                    lodIndex++;
                }
            });
            mapViewProperties = {
                map,
                spatialReference: new SpatialReference({
                    wkid: 102100,
                }),
                constraints: {
                    lods: levelOfDetails
                },
                center: mapDefaults.center,
                zoom: mapDefaults.zoom
            };
        }
        else {
            mapViewProperties = {
                map,
                spatialReference: new SpatialReference({
                    wkid: 102100,
                }),
                center: mapDefaults.center,
                zoom: mapDefaults.zoom
            };
        }
        const mapView = new MapView(mapViewProperties);
        mapView.ui.move("zoom", "bottom-right");
        this.moduleSettingsService.$systemModuleSettings.pipe(take(1)).subscribe(settings => {
            const defaultExtentSetting = settings.find(setting => setting.moduleId === moduleId && setting.key?.toLowerCase() === "defaultextent" && !!setting.value);
            if (defaultExtentSetting) {
                try {
                    const extent = new Extent(JSON.parse(defaultExtentSetting.value));
                    mapView.extent = extent;
                }
                catch (e) {
                    this.appController.showMessage("Module's default extent is incorrectly set. Please contact your system administrator.", AlertType.Success);
                }
            }
            if (!mapView.extent) {
                this.userInformationService.$systemOrganisations.pipe(take(1)).subscribe(() => {
                    const organisationId = this.userInformationService.getOrganisationId(moduleId);
                    const organisation = organisationId
                        ? this.userInformationService.getOrganisationInformation(organisationId)
                        : null;
                    const defaultExtent = organisation?.defaultExtent;
                    if (defaultExtent) {
                        try {
                            const extent = new Extent(JSON.parse(defaultExtent));
                            mapView.extent = extent;
                        }
                        catch (e) {
                            this.appController.showMessage("Organisation's default extent is incorrectly set. Please contact your system administrator.", AlertType.Success);
                        }
                    }
                });
            }
        });
        this.mapTools.mapTools = [];
        this.mapTools.addDraw(mapView);
        this.mapTools.addSearch(mapView);
        this.mapTools.addBasemaps(mapView);
        // this.mapTools.addPrint(mapView, moduleId);
        this.mapTools.addMeasure(mapView);
        this.mapTools.addLegend(mapView);
        this.mapTools.addLayerList(mapView);
        this.mapTools.addBookmark(mapView);
        this.mapTools.addHome(mapView);
        reactiveUtils.when(() => mapView?.ready === true, () => {
            this.checkForSysAdmin(mapView);
        });
        return mapView;
    }
    getMapView(mapDefaults, moduleId) {
        this._mapView = this.createMapView(mapDefaults, moduleId);
        // this.addPropertyLayer(this._mapView);
        return this._mapView;
    }
    getTokenRequestParams(layer) {
        for (const map of this.userMaps) {
            if (layer.url.includes(map.url)) {
                let identityToken = "";
                this.authService.$authenticationToken.subscribe((tokenChange) => {
                    identityToken = tokenChange;
                });
                const tokenRequestParams = {
                    authorization: `Bearer ${identityToken}`,
                    MapServiceId: `${map.id}`
                };
                return tokenRequestParams;
            }
        }
    }
    getLayerToken(endPointUrl, params) {
        return this.http.get(endPointUrl, params)
            .pipe(rxjsOperators.map(response => {
            return response;
        }));
    }
    // check if maps are available
    checkIfMapsAreLoaded() {
        if (this.userMaps.length > 0) {
            this.subscribeToMapsLoaded(this._mapView);
        }
    }
    subscribeToMapsLoaded(mapView) {
        this.addMapsInSearchComponent(mapView);
    }
    // adds the maps into the search widget
    addMapsInSearchComponent(mapView) {
        const searchWidget = mapView?.ui?.find("searchWidget");
        mapView.map?.layers.forEach((layer) => {
            if (layer.type === "feature" && this.isSelectionLayer(layer)) {
                const l = layer;
                l.load().then((loadedMapLayer) => {
                    const source = this.prepareSearchSource(loadedMapLayer);
                    if (source.name === "Property") {
                        const searchLayers = this.preparePropertySearchSources(loadedMapLayer);
                        searchWidget.sources.addMany(searchLayers);
                    }
                    searchWidget.sources.push(source);
                    searchWidget.sources.sort((a, b) => a.name.localeCompare(b.name));
                });
            }
        });
    }
    // This function builds and returns a LayerSearchSource for a given layer
    prepareSearchSource(loadedMapLayer) {
        const fields = loadedMapLayer.fields
            .filter((field) => !this.forbiddenFields.includes(field.name.toLowerCase().trim()) && (field.type !== "small-integer" && field.type !== "date" && field.type !== "geometry"))
            .map(field => field.name);
        const suggestionTemplate = fields?.map((field, index) => `<span><strong>${fields[index]}:</strong> {${field}}</span> <br>`).join("");
        return new LayerSearchSource({
            layer: loadedMapLayer,
            searchFields: fields,
            suggestionTemplate,
            exactMatch: false,
            placeholder: `Search ${loadedMapLayer.title}`,
            outFields: ["*"],
            name: loadedMapLayer.title,
            withinViewEnabled: false,
            suggestionsEnabled: true,
            maxSuggestions: 50,
            minSuggestCharacters: 1,
        });
    }
    // This function builds and returns additional LayerSearchSources[] if the module contains a property layer
    preparePropertySearchSources(loadedMapLayer) {
        const fields = loadedMapLayer.fields
            .filter((field) => !this.forbiddenFields.includes(field.name.toLowerCase().trim()) && (field.type !== "small-integer" && field.type !== "date" && field.type !== "geometry"))
            .map(field => field.name);
        const suggestionTemplate = fields?.map((field, index) => `<span><strong>${fields[index]}:</strong> {${field}}</span> <br>`).join("");
        const layerSources = [];
        if (fields.find(field => field.toLowerCase() === "erfno")) {
            layerSources.push(new LayerSearchSource({
                layer: loadedMapLayer,
                searchFields: ["ErfNo"],
                suggestionTemplate,
                exactMatch: false,
                placeholder: `Search Erf Number`,
                outFields: ["*"],
                name: "Erf Number",
                withinViewEnabled: false,
                suggestionsEnabled: true,
                maxSuggestions: 50,
                minSuggestCharacters: 1,
            }));
        }
        if (fields.find(field => field.toLowerCase() === "farmno")) {
            layerSources.push(new LayerSearchSource({
                layer: loadedMapLayer,
                searchFields: ["FarmNo"],
                suggestionTemplate,
                exactMatch: false,
                placeholder: `Search Farm Number`,
                outFields: ["*"],
                name: "Farm Number",
                withinViewEnabled: false,
                suggestionsEnabled: true,
                maxSuggestions: 50,
                minSuggestCharacters: 1,
            }));
        }
        if (fields.find(field => field.toLowerCase() === "allotment")) {
            layerSources.push(new LayerSearchSource({
                layer: loadedMapLayer,
                searchFields: ["Allotment"],
                suggestionTemplate,
                exactMatch: false,
                placeholder: `Search Allotment`,
                outFields: ["*"],
                name: "Allotment",
                withinViewEnabled: false,
                suggestionsEnabled: true,
                maxSuggestions: 50,
                minSuggestCharacters: 1,
            }));
        }
        if (fields.find(field => field.toLowerCase() === "sectionaltitleschemeid")) {
            layerSources.push(new LayerSearchSource({
                layer: loadedMapLayer,
                searchFields: ["SectionalTitleSchemeID"],
                suggestionTemplate,
                exactMatch: false,
                placeholder: `Search Sectional Title Scheme Id`,
                outFields: ["*"],
                name: "Sectional Title Scheme Id",
                withinViewEnabled: false,
                suggestionsEnabled: true,
                maxSuggestions: 50,
                minSuggestCharacters: 1,
            }));
        }
        if (fields.find(field => field.toLowerCase() === "titledeed")) {
            layerSources.push(new LayerSearchSource({
                layer: loadedMapLayer,
                searchFields: ["TitleDeed"],
                suggestionTemplate,
                exactMatch: false,
                placeholder: `Search Title Deed`,
                outFields: ["*"],
                name: "Title Deed",
                withinViewEnabled: false,
                suggestionsEnabled: true,
                maxSuggestions: 50,
                minSuggestCharacters: 1,
            }));
        }
        if (fields.find(field => field.toLowerCase() === "sgcode")) {
            layerSources.push(new LayerSearchSource({
                layer: loadedMapLayer,
                searchFields: ["SgCode"],
                suggestionTemplate,
                exactMatch: false,
                placeholder: `Search SG Code`,
                outFields: ["*"],
                name: "SG Code",
                withinViewEnabled: false,
                suggestionsEnabled: true,
                maxSuggestions: 50,
                minSuggestCharacters: 1,
            }));
        }
        if (fields.find(field => field.toLowerCase() === "address")) {
            layerSources.push(new LayerSearchSource({
                layer: loadedMapLayer,
                searchFields: ["Address"],
                suggestionTemplate,
                exactMatch: false,
                placeholder: `Search Address`,
                outFields: ["*"],
                name: "Address",
                withinViewEnabled: false,
                suggestionsEnabled: true,
                maxSuggestions: 50,
                minSuggestCharacters: 1,
            }));
        }
        return layerSources;
    }
    // This function checks whether a layer is a selection layer
    isSelectionLayer(selectedLayer) {
        let isSelectionLayer = false;
        for (const userMap of this.userMaps) {
            if (userMap.layer.id === selectedLayer.id && userMap.selectionLayerType.toLowerCase() !== "application") {
                isSelectionLayer = true;
                break;
            }
        }
        return isSelectionLayer;
    }
    getBufferByModule() {
        let defaultQueryBuffer = 0;
        if (this.moduleConfigService.isStreetNamingModule()) {
            defaultQueryBuffer = 12;
        }
        return defaultQueryBuffer;
    }
    getServerTokens(moduleId) {
        return this.http.get(`${ApiModuleMapConstants.URL}/${moduleId}/${ApiModuleMapConstants.FUNCTION_GET_ARCGIS_SERVER_TOKENS}`, {})
            .pipe(map((result) => {
            IdentityManager.destroyCredentials();
            result.servers.forEach(server => {
                const myTokenObject = {
                    token: server.token, // The actual token string
                    server: server.server + "/rest/services", // The URL of the secure service
                    expires: new Date().getTime() + (60 * 60 * 1000) // Example expiration (e.g., 1 hour from now)
                };
                // Register the token with the IdentityManager
                IdentityManager.registerToken(myTokenObject);
            });
            return result;
        }));
    }
    static ctorParameters = () => [
        { type: MapTools },
        { type: HttpClient },
        { type: AuthService },
        { type: SystemModuleSettingsService },
        { type: UserInformationService },
        { type: ModuleConfigService },
        { type: Location },
        { type: RequestStatusService },
        { type: AppControllerService }
    ];
};
MapService = MapService_1 = __decorate([
    Injectable({
        providedIn: "root"
    }),
    AutoUnsubPortal()
], MapService);
export { MapService };
